import React from 'react';
import IntercomChat from 'common/containers/intercom_chat';

/**
 * PAP0 wrapper.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Wrapper = ({children}) => (
  <div className="l-content pap0" id="content">
    { children }

    <IntercomChat />
  </div>
)

export default Wrapper;



// WEBPACK FOOTER //
// ./pap0/components/wrapper.jsx